module.exports = __webpack_public_path__ + "diametro-da-terra.a62c600383b64645849df47b7e9e6092.jpg";